module.exports = __webpack_public_path__ + "media/images/emoticons/cd-ac77ebb9d8f9b5172215b8ee8cc54414.gif";